import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'dev/workflows',
  children: {},
} as const satisfies Location
